import axios from "axios";
import {isEmpty} from "../../global-components/admin/inc/Helpers";

const csrf = document.head.querySelector('meta[name="csrf-token"]');

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['X-CSRF-TOKEN'] = csrf.content;
axios.defaults.headers.common['X-localization'] = document.documentElement.lang;

export async function get(endpoint, params = {}) {
    let searchParams = (isEmpty(params)) ? '' : '?' + new URLSearchParams(params).toString();
    return axios.get(`/api/site/${endpoint}${searchParams}`);
}

export async function download(endpoint) {
    return axios({
        url: `${endpoint}`,
        method: 'GET',
        responseType: 'blob', // important
    });
}

export async function getRaw(endpoint, params) {
    return axios.get(endpoint);
}

export async function post(endpoint, data = {}) {
    return axios.post(`/api/site/${endpoint}`, data);
}

export async function postCustomEndpoint(endpoint, data = {}) {
    return axios.post(`/${endpoint}`, data);
}

